// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"67cc3c43","52":"4ebd4b19","131":"31cd539f","239":"61d7c150","325":"001b52fe","422":"1d1232e3","455":"543ebdfd","531":"d7f323f8","599":"54900321","650":"e413159e","857":"4dee11d4","971":"99ba7823"}[chunkId] + ".chunk.js";
};